<template>
    <div id="topnavdefault_main">
        <div id="topnavdefault_first">
            <joat class="fc-white fs-bigger"></joat>
        </div>
        <div id="topnavdefault_second">
            <select-project></select-project>
        </div>
        <div id="topnavdefault_last">
            <user-info class="fc-white"></user-info>
        </div>
    </div>
</template>

<script>
  import Joat from '../miscellaneous/joat'
  import UserInfo from '../miscellaneous/userInfo'
  import SelectProject from '../projects/selectProject'
  export default {
    name: 'topNavDefault',
    components: { SelectProject, UserInfo, Joat },
    props:{

    }
  }
</script>

<style scoped>
    #topnavdefault_main{
        display: flex;
        height: 100%;
        width: 100%;
        align-items: center;
    }
    #topnavdefault_first{
        display: flex;
        height: 100%;
        padding-left: 20px;
        width: calc(var(--layout-left-width) - 20px);
    }
    #topnavdefault_second{
        display: flex;
        height: 100%;
        align-items: center;
    }
    #topnavdefault_last{
        display: flex;
        height: 100%;
        align-items: center;
        margin-left: auto;
        padding-right: 20px;
    }
</style>
